module.exports = __webpack_public_path__ + "fonts/OpenSans-ExtraBold.1b2c3c47.woff2";